export default {
    control: base => ({
    ...base,
    border: 0,
    })
};